module.exports = __webpack_public_path__ + "img/1.94f87f98.png";